import {
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Form, Formik, FieldArray } from "formik";

import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { Delete } from "@mui/icons-material";
import FormControl from "Components/MUI_components/FormControl/fomikFormControl";
import Stepper from "Components/MUI_components/stepper";
import customerService from "Service/Customer/customer.service";
import itemMasterService from "Service/Item-master/itemMaster.service";
import { currency } from "Components/MUI_components/currencyFormatterTag";
import Loading from "Components/MUI_components/loading";
import { useDispatch } from "react-redux";
import salesOrderService from "Service/Stock/salesOrder.service";
import { openSnackbar } from "Redux/Actions/snackbarActions";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";

const AddSalesOrder = ({ setOpen, code, setSubmitted }) => {
  const dispatch = useDispatch();
  const [isLoaded, setIsLoaded] = useState(false);

  const initValues = {
    customer: null,
    remarks: "",
    itemMaster: null,
    qty: "",
    salesOrderData: [],
  };

  const [initValue, setInitValue] = useState(initValues);

  useEffect(() => {
    const getSalesOrder = async () => {
      if (code) {
        try {
          let response = await salesOrderService.get(code);
          response = JSON.parse(
            JSON.stringify(response).replace(/:null/gi, ':""')
          );
          setInitValue(response);

        } catch (e) {
          dispatch(openSnackbar(true, "error", e));
        }
      } else {
        setInitValue(initValues)
      }
      setIsLoaded(true);
    };
    getSalesOrder()

  }, [code, dispatch]);

  const Validation = yup.object({
    customer: yup.object().required("Customer is required").nullable(),
  });

  const [activeStep, setActiveStep] = React.useState(0);

  const getSteps = ["Sales order", "Ordered items"];
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const handleSubmit = async (values) => {
    try {
      const totalAmount = values.salesOrderData
        .map(({ quantity, retailPrice }) => quantity * retailPrice)
        .reduce((sum, i) => sum + i, 0);

      if (code)
        await salesOrderService.edit({ ...values, totalAmount: totalAmount }, code);
      else
        await salesOrderService.create({ ...values, totalAmount: totalAmount });
      setSubmitted((prev) => !prev);
      setOpen(false);
      dispatch(
        openSnackbar(
          true,
          "success",
          `Stock Issue ${code ? "updated" : "created"} successfully`
        )
      );
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };
  const handleLineDiscount = (data) => {
    const { quantity, itemMaster, discountAmount, discountPercentage } = data;
    let price = itemMaster.retailPrice;
    let total = quantity * price;
    let discountAmt = discountAmount * quantity;
    return total - total * (discountPercentage / 100) - discountAmt;
  };

  return (
    <>
      {isLoaded ? (
        <Formik
          initialValues={initValue}
          validationSchema={Validation}
          onSubmit={async (values) => {
            if (activeStep === getSteps.length - 1) {
              await handleSubmit(values);
            } else handleNext();
          }}
        >
          {(props) => (
            <Form>
              <Stepper
                getSteps={getSteps}
                StepContent={getStepContent}
                activeStep={activeStep}
                values={props.values}
                setFieldValue={props.setFieldValue}
              />

              <div className="row space-between mb">
                <Button
                  disabled={activeStep === 0 || props.isValid === false}
                  onClick={handleBack}
                >
                  Back
                </Button>
                <div style={{ display: "flex" }}>
                  <Button
                    disabled={
                      props.isSubmitting ||
                        (!props.values.salesOrderData.length &&
                          activeStep === getSteps.length - 1)
                        ? true
                        : false
                    }
                    startIcon={
                      props.isSubmitting && (
                        <CircularProgress color="inherit" size={20} />
                      )
                    }
                    variant="contained"
                    type="submit"
                    color="secondary"
                  >
                    {activeStep === getSteps.length - 1 ? "Complete" : "Next"}
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      ) : (
        <Loading />
      )}
    </>
  );
  function getStepContent(step, values, setFieldValue) {
    const totalAmount = values.salesOrderData
      .map((data) => handleLineDiscount(data))
      .reduce((sum, i) => sum + i, 0);
    switch (step) {
      case 0:
        return (
          <>
            <div className="row">
              <div className="col-4">
                <FormControl
                  control="asynchronousAutoComplete"
                  label="Customer"
                  name="customer"
                  Service={customerService}
                  getOptionLabel={(option) =>
                    option.firstName +
                    " " +
                    (option.secondName ?? "") +
                    " - " +
                    (option.phone1 ?? "")
                  }
                />
              </div>
              <div className="col-8">
                <FormControl name="remarks" label="Remarks" control="input" />
              </div>
            </div>
          </>
        );
      case 1:
        return (
          <FieldArray name="salesOrderData">
            {(salesOrderDataProps) => (
              <>
                <div className="row">
                  <div className="col-8">
                    <FormControl
                      control="asynchronousAutoComplete"
                      label="Product"
                      name={`itemMaster`}
                      Service={itemMasterService}
                      getOptionLabel={(option) =>
                        option.name + " " + option.code
                      }
                    />
                  </div>
                  <div className="col-4">
                    <FormControl label="Qty" name="qty" control="input" />
                  </div>
                </div>
                <div className="row flex-end">
                  <Button
                    variant="contained"
                    disabled={!values.itemMaster}
                    onClick={() => {
                      salesOrderDataProps.push({
                        itemMaster: values.itemMaster,
                        retailPrice:values.itemMaster.retailPrice,
                        quantity: values.qty ? values.qty : 1,
                        discountAmount: 0,
                        discountPercentage: 0,
                        discountTotal: 0,
                        subTotal: 0,
                        total: 0,
                      });
                      setFieldValue("itemMaster", null);
                      setFieldValue("qty", "");
                    }}
                  >
                    Add
                  </Button>
                </div>
                <div className="row mt mb">
                  <TableContainer>
                    <Table size="small" aria-label="spanning table">
                      <TableHead style={{ backgroundColor: "#cacaca50" }}>
                        <TableRow>
                          <TableCell align="center" colSpan={7}>
                            Details
                          </TableCell>
                          <TableCell align="right">Price</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell width="5"></TableCell>
                          <TableCell width="5">#</TableCell>
                          <TableCell>{COLUMNS_NAME.DESCRIPTION}</TableCell>
                          <TableCell align="right">{COLUMNS_NAME.QUANTITY}</TableCell>
                          <TableCell align="right">{COLUMNS_NAME.UNIT_PRICE}</TableCell>
                          <TableCell align="right">{COLUMNS_NAME.DISCOUNT_PERCENTAGE}</TableCell>
                          <TableCell align="right">{COLUMNS_NAME.DISCOUNT_AMOUNT}</TableCell>
                          <TableCell align="right">{COLUMNS_NAME.TOTAL}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {values.salesOrderData.map((data, i) => (
                          <TableRow key={i}>
                            <TableCell width="5">
                              <Delete
                                color="secondary"
                                style={{
                                  fontSize: 18,
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  if (
                                    window.confirm(
                                      "Are you sure want to delete this?"
                                    )
                                  )
                                    salesOrderDataProps.remove(i);
                                }}
                              />
                            </TableCell>
                            <TableCell width="5">{i + 1}</TableCell>
                            <TableCell>{data.itemMaster.name}</TableCell>
                            <TableCell align="right">
                              <FormControl
                                control="customInput"
                                name={`salesOrderData[${i}].quantity`}
                              />
                            </TableCell>
                            <TableCell align="right">
                              <FormControl
                                control="customInput"
                                name={`salesOrderData[${i}].itemMaster.retailPrice`}
                              />
                            </TableCell>
                            <TableCell align="right">
                              <FormControl
                                control="customInput"
                                name={`salesOrderData[${i}].discountAmount`}
                              />
                            </TableCell>
                            <TableCell align="right">
                              <FormControl
                                control="customInput"
                                name={`salesOrderData[${i}].discountPercentage`}
                              />
                            </TableCell>

                            <TableCell align="right">
                              {currency(handleLineDiscount(data))}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <TableHead>
                        {values.salesOrderData.length === 0 ? (
                          <TableRow>
                            <TableCell align="center" colSpan={8}>
                              No Data
                            </TableCell>
                          </TableRow>
                        ) : (
                          <>
                            <TableRow>
                              <TableCell colSpan={6} />
                              <TableCell>
                                <strong>{COLUMNS_NAME.LAST_TOTAL}</strong>
                              </TableCell>
                              <TableCell align="right">
                                <strong>{currency(totalAmount)}</strong>
                              </TableCell>
                            </TableRow>
                          </>
                        )}
                      </TableHead>
                    </Table>
                  </TableContainer>
                </div>
              </>
            )}
          </FieldArray>
        );
      default:
        return null;
    }
  }
};

export default AddSalesOrder;
